import React, { useEffect, useState } from "react";
import api from "../../api";
import { toast } from "sonner";

export default function AdminThemes() {
  const [themes, setThemes] = useState([]);
  useEffect(() => { api.get("/admin/themes").then((r) => setThemes(r.data)); }, []);

  const updateStatus = async (id, status) => {
    try {
      await api.patch(`/admin/themes/${id}`, { status });
      toast.success("Updated");
      setThemes((t) => t.map((x) => x.id === id ? { ...x, status } : x));
    } catch { toast.error("Failed"); }
  };

  return (
    <div data-testid="admin-themes-screen">
      <h1 className="font-display text-4xl mb-2">Themes</h1>
      <p className="text-muted-foreground mb-8">Order, status and milestone titles.</p>
      <div className="space-y-3">
        {themes.map((t) => (
          <div key={t.id} className="card-soft p-5 flex items-center gap-4">
            <div className="w-12 h-12 rounded-2xl bg-[hsl(var(--neu-paper))] flex items-center justify-center font-display text-xl">
              {t.month_number || "-"}
            </div>
            <div className="flex-1">
              <div className="font-display text-xl">{t.title}</div>
              <div className="text-xs text-muted-foreground">{t.slug} · {t.subtitle}</div>
              {t.milestone_badge_title && (
                <div className="text-xs text-[hsl(var(--neu-orange))] mt-1">
                  🏅 {t.milestone_badge_title}
                </div>
              )}
            </div>
            <select value={t.status} onChange={(e) => updateStatus(t.id, e.target.value)}
                     className="field w-auto py-2 px-3 text-sm" data-testid={`admin-theme-status-${t.slug}`}>
              <option value="published">Published</option>
              <option value="coming_soon">Coming soon</option>
              <option value="locked">Locked</option>
              <option value="archived">Archived</option>
            </select>
          </div>
        ))}
      </div>
    </div>
  );
}
